import { Subject } from 'rxjs';

export function openFilePicker(types: string | string[]) {
    const subject = new Subject<File>();

    const input = document.createElement('input');
    input.style.display = 'none';
    input.type = 'file';
    input.accept = Array.isArray(types) ? types.join(',') : types;
    input.multiple = false;

    document.body.appendChild(input);
    input.click();

    input.addEventListener('change', () => {
        if (input.files && input.files.length > 0) {
            subject.next(input.files[0]);
        }

        subject.complete();
        input.remove();
    });

    return subject.asObservable();
}